import React, { useEffect, useState } from "react";
import { config } from "../../../../config";
import { MESSAGE_STATUS, loadColumns } from "../../../../Util/helper";
import axiosApi from "../../../../core/interceptor/interceptor";
import DataTableComponent from "../../../../Util/DataTable/DataTable";
import "./TextLogs.css";
import Tab from "../../../../Util/Tabs/Tab";
import { AsyncPaginate } from 'react-select-async-paginate';
import CustomSelect from "../../../../Util/CustomSelect/CustomSelect";
import WarningDialogue from "../../../../Util/WarningDialogue";
import DatePicker from "react-datepicker";
import RateCard from "../../../../Util/RateCard/RateCard";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function TextLogs() {
  const [cancelMessagesIds, setCancelMessagesIds] = useState([]);
  const [smsUsageReport, setSmsUsageReport] = useState({
    sms: {},
    outbound: {},
    inbound: {}
  });
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: '',
      },
    },
  };

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      lineHeight: "16px",
      wordBreak: "break-word",
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer"
    })
  }

  const [userData, setUserData] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 50,
    sort_column: 'created_at',
    direction: 'desc',
    search_string: '',
    sms_type: window.location.href?.includes("/league-reminders") ? 'league_reminder' : 'general_reminder',
    league_id: null,
  });
  const [totalPage, setTotalPage] = useState(0);
  const [selectedTab, setSelectedTab] = useState(window.location.href?.includes("/league-reminders") ? '/league-reminders' : '');
  const [columns, setColumns] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [selectedLeagues, setSelectedLeague] = useState(null);
  const [selectedTeams, setSelectedTeams] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [teamKey, setTeamKey] = useState(Math.floor(Math.random() * 90000) + 10000);

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [showCancelMultiple, setShowCancelMultiple] = useState(false);
  const [overviewData, setOverviewData] = useState({});
  const [chartMonthlydata, setChartMonthlydata] = useState();
  const [showChart, setShowChart] = useState(false);
  const storedSeason = localStorage.getItem('selectedSeason');
  const [selectedSeason, setSelectedSeason] = useState(storedSeason ? JSON.parse(storedSeason) : { id: 0, name: 'All', created_by: 0, created_at: '0', title: 'All' });
  const [seasonsList, setSeasonsList] = useState([]);
  const [leagueKey, setLeagueKey] = useState(0);
  const [seasonLeagueIds, setSeasonLeagueIds] = useState([]);
  const [stop, setStop] = useState(true);

  useEffect(() => {
    getAllSeasons();
  }, [])

  useEffect(() => {
    setStop(true);
    setSeasonLeagueIds([]);
    setSelectedLeague(null);
    setSelectedTeams(null);
    setLeagueKey((key) => key + 1);
    setTeamKey(Math.floor(Math.random() * 90000) + 10000);
    if (selectedSeason?.id) {
      axiosApi.get(`${config.apiUrl}/misc/leagues/${selectedSeason.id}`).then(res => {
        const leagueIds = res?.data?.data?.map(item => item.id)
        setSeasonLeagueIds(leagueIds);
        if (leagueIds.length) {
          getSmsLogs(leagueIds, true);
        }
      })
    } else {
      getSmsLogs([], true);
    }
  }, [selectedSeason])

  useEffect(() => {
    if (!stop) {
      getSmsLogs();
    }
  }, [filter, selectedLeagues, selectedTeams, statusFilter]);

  useEffect(() => {
    setColumns([
      {
        name: 'Select',
        type: 'conditional-select',
        selector: 'selected',
        sortable: false,
        actionHandler: (id, checked, row) => {
          if (new Date(row.schedule_date_time_tz) > new Date() && row.status === 'scheduled') {
            const newMessagesCancelIds = [...cancelMessagesIds];
            if (checked) {
              newMessagesCancelIds.push(row.id);
            } else {
              const idx = newMessagesCancelIds.findIndex(x => x === row.id);
              if (idx >= 0) {
                newMessagesCancelIds.splice(idx, 1);
              }
            }
            setCancelMessagesIds(newMessagesCancelIds);
            if (newMessagesCancelIds.length) {
              setShowCancelMultiple(true);
            } else {
              setShowCancelMultiple(false);
            }
          }
        },
      },
      {
        name: 'Name',
        selector: 'user.full_name'
      },
      {
        name: 'Phone',
        selector: 'user.cell_phone'
      },
      {
        name: 'Message',
        selector: 'body'
      },
      {
        name: 'Message Date',
        selector: 'schedule_date_time_tz',
        type: 'datetime',
      },
      {
        name: 'Status',
        selector: 'status'
      },
      {
        name: 'Created At',
        selector: 'created_at',
        type: 'datetime'
      },
    ])
  }, [cancelMessagesIds])

  const getChartData = () => {

    axiosApi.get(`${config.apiUrl}/messages/charts-data`, {
      params: { ...filter, year: 2023 },
    })
      .then((response) => {
        const chartData = response.data.data;
        const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const monthlyCounts = Array.from({ length: 12 }, () => 0);

        for (const item of chartData) {
          monthlyCounts[item.month - 1] = item.count;
        }
        const data = {
          labels,
          datasets: [
            {
              label: 'Sent Messages',
              data: monthlyCounts,
              backgroundColor: '#00788B',
            }
          ],
        };
        setChartMonthlydata(data);
      });
  }

  const getCostingReport = () => {
    axiosApi.get(`${config.apiUrl}/messages/costing`, {
      params: {
        startDate: moment().startOf('year').toDate(),
        endDate: moment().endOf('year').toDate(),
      },
    })
      .then((response) => {
        if (response?.data?.data) {
          setSmsUsageReport(response?.data?.data);
        }
      });
  }

  const getSmsLogs = (leagueIds = [], update = false) => {
    axiosApi.get(`${config.apiUrl}/messages`, {
      params: { ...filter, league_id: leagueIds.length ? leagueIds : (!update && selectedLeagues?.id) ? [selectedLeagues?.id] : (!update && seasonLeagueIds.length) ? seasonLeagueIds : [], team_id: (!update && selectedTeams?.id) ? selectedTeams?.id : undefined, status: statusFilter, messageStartDate: startDate ? moment(moment(startDate).format('YYYY-MM-DD')).startOf('day').format('YYYY-MM-DD HH:mm:ss') : null, messageEndDate: endDate ? moment(moment(endDate).format('YYYY-MM-DD')).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null },
    })
      .then((response) => {
        setUserData(response.data.data.rows);
        setTotalPage(response.data.data.count);
        setOverviewData(response.data.data.overview);
      }).finally(() => {
        setStop(false);
      });
  }

  useEffect(() => {
    getChartData();
    if (columns.length) {
      updateColumns();
    }
    getCostingReport();
  }, [selectedTab])

  useEffect(() => {
    if (startDate && endDate) {
      setTimeout(() => {
        getSmsLogs();
      });
    }
  }, [dateRange])

  const updateColumns = () => {
    const prevColumns = [...columns];
    const alreadyHasColumns = columns.some(column => column.name === "League" || column.name === "Team");
    if (selectedTab === '/league-reminders' && !alreadyHasColumns) {
      prevColumns.splice(2, 0,
        {
          name: 'League',
          selector: 'league.name'
        },
        {
          name: 'Team',
          selector: 'team.name'
        }
      );
      setColumns(prevColumns);
    } else {
      if (alreadyHasColumns) {
        prevColumns.splice(2, 2);
        setColumns(prevColumns);
      }
    }
  }

  const search = () => {
    setFilter(prev => ({ ...prev, search_string: searchString.trim() }));
  }

  const getLeaguesInSeason = async (page_, searchString, seasonId) => {
    const leagues = await axiosApi.get(`${config.apiUrl}/misc/leagues/${seasonId}`, { params: { page: page_, search_string: searchString, sortColumn: 'id' } });
    return leagues.data.data;
  }

  const getTeamByLeague = async (page_, searchString) => {
    let leagueIds = '';
    seasonLeagueIds?.forEach(id => {
      leagueIds = leagueIds.length ? `${leagueIds},${id}` : `${id}`;
    });
    const leagueId = selectedLeagues?.id ? `${selectedLeagues?.id}` : leagueIds.length ? leagueIds : '';
    const teams = await axiosApi.get(`${config.apiUrl}/misc/teams`, { params: { page: page_, search_string: searchString, leagueId } });
    return teams.data.data;
  }

  const loadOptionsLeague = async (searchQuery, loadedOptions, { page }) => {
    const leagues = await getLeaguesInSeason(page, searchQuery, selectedSeason?.id || 0);
    return {
      options: leagues,
      hasMore: leagues.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsTeam = async (searchQuery, loadedOptions, { page }) => {
    const teams = await getTeamByLeague(page, searchQuery);
    return {
      options: teams,
      hasMore: teams.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const cancelScheduledMessage = () => {
    axiosApi.put(`${config.apiUrl}/messages/cancel-messages`, {
      cancel_ids: cancelMessagesIds,
    }).then(() => {
      getSmsLogs();
      setOpenWarningPopup(false);
      setCancelMessagesIds([]);
    }).catch((err) => {
      setOpenWarningPopup(false);
      console.error(err);
    });
  }

  const getAllSeasons = (search = null) => {
    axiosApi.get(`${config.apiUrl}/seasons`, { params: { search: search ? search : filter.name, } }).then((response) => {
      if (response.data.data) {
        setSeasonsList(() => ([{ id: 0, name: 'All', created_by: 0, created_at: '0', title: 'All' }, ...response.data.data]));
      }
    }).catch((error) => {
      console.log("Error while getting season list in sms logs, error => ", error.message || 'Unknown error');
    })
  }

  return (
    <>
      <div className="content-wrapper leagues-wrapper indv-wrapper content-wrapper-rs">
        <div className="heading-wrapper">
          <div className="left">
            <h2 className="heading"> SMS Logs </h2>
          </div>
        </div>
        <Tab tabs={[
          {
            name: "League Reminders",
            url: "/league-reminders"
          },
          {
            name: "General Reminders",
            url: ""
          },
        ]} emit={(e) => {
          setFilter(() => {
            const filter_ = {
              limit: 50,
              page: 1,
              sort_column: 'created_at',
              direction: 'desc',
              sms_type: e === "/league-reminders" ? "league_reminder" : "general_reminder",
            };
            setSelectedTab((prevTab) => {
              if (prevTab !== e) {
                setSelectedTeams(null);
                setSelectedLeague(null);
                setCancelMessagesIds([]);
                setShowCancelMultiple(false);
                setStatusFilter(null);
                setSearchString('');
              }
              return e;
            });
            return filter_;
          });
        }}
        />


        <div className="table-wrapper overview-wrapper user-wrapper">
          <div className="search-blk league-search ind-reg-resp">
            <div className="header-blk">
              <h2>Overview</h2>
            </div>
            <div className="cards-wrapper">
              <div className="cards-blk">
                <RateCard text='Overall SMS Sent' value={overviewData?.totalSmsSent} />
                <RateCard text='SMS Sent in Last 24 Hours' value={overviewData?.sentIn24Hrs} />
                <RateCard text='SMS Sent in Current Month' value={overviewData?.sentInPastMonth} />
                <RateCard text='EST in Current Month' value={smsUsageReport?.sms?.price ? `$${overviewData?.sentInPastMonth ? (overviewData?.sentInPastMonth * .008) : 0}` : 0} />
              </div>
            </div>
            <div className={showChart ? "chart-bar-rs open" : "chart-bar-rs"}>
              <div className="chart-bar-rs-header" onClick={() => setShowChart(!showChart)}>
                <h2>Monthly SMS Sent in the Past 1 Year</h2>
              </div>
              <div className="chart-block">
                {chartMonthlydata && showChart && <Bar data={chartMonthlydata} options={options} />}
              </div>
            </div>
            <h2>SMS Logs Filters</h2>
            <div className="input-blk sms-log-filters">
              <div className="search-bar">
                <div className="input-field">
                  <label>Search</label>
                  <input type="text" id="search_bar" name="search" title="Search by Name, Phone Number, Message..." placeholder={'Search by Name, Phone Number, Message...'} value={searchString} onChange={(e) => setSearchString(e.target.value)} />
                </div>
                <button type='submit' onClick={search}>Search</button>
              </div>

              <div className="input-field">
                <label>Date Range</label>
                <div className="date-blk">
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                  />
                </div>
              </div>
              <CustomSelect
                label={'Status'}
                data={[
                  {
                    id: '',
                    title: 'All'
                  },
                  {
                    id: 'scheduled',
                    title: 'Scheduled'
                  },
                  {
                    id: 'processing',
                    title: 'Processing'
                  },
                  {
                    id: 'processed',
                    title: 'Processed'
                  },
                  {
                    id: 'sent',
                    title: 'Sent'
                  },
                  {
                    id: 'delivery_unknown',
                    title: 'Delivery Unknown',
                  },
                  {
                    id: 'delivered',
                    title: 'Delivered'
                  },
                  {
                    id: 'undelivered',
                    title: 'Undelivered'
                  },
                  {
                    id: 'failed',
                    title: 'Failed'
                  },
                  {
                    id: 'received',
                    title: 'Received'
                  },
                  {
                    id: 'disabled',
                    title: 'Disabled'
                  },
                  {
                    id: 'canceled',
                    title: 'Canceled'
                  },
                ]}
                placeholder={statusFilter ? MESSAGE_STATUS[statusFilter] : 'All'}
                type={'status'}
                onSelect={(ele) => ele && setStatusFilter(ele.id)}
                selector="title"
              />

              {selectedTab === '/league-reminders' && <div className="drop-wrapper league-team-wrapper">
                <CustomSelect
                  label={'Season'}
                  data={seasonsList}
                  placeholder={selectedSeason?.title || "All"}
                  type={'Season'}
                  onSelect={(ele) => {
                    if (ele) {
                      setSelectedSeason(ele);
                      localStorage.setItem('selectedSeason', JSON.stringify(ele));
                    }
                  }}
                />
              </div>}

              {selectedTab === '/league-reminders' && <div className="drop-wrapper league-team-wrapper">
                <div className="drop-down">
                  <label>League</label>
                  <AsyncPaginate
                    classNamePrefix="cs-new-dropdown"
                    isClearable={true}
                    key={leagueKey}
                    value={selectedLeagues}
                    loadOptions={loadOptionsLeague}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(option) => {
                      setSelectedLeague(option);
                      setSelectedTeams(null);
                      setTeamKey(Math.floor(Math.random() * 90000) + 10000);
                    }}
                    placeholder="Select League"
                    additional={{
                      page: 1,
                    }}
                    debounceTimeout={1000}
                    styles={customStyles}
                    noOptionsMessage={() => "No Leagues Found."}
                    className="multivalue-dropdown"
                  // closeMenuOnSelect={false}
                  />
                </div>
              </div>}

              {selectedTab === '/league-reminders' && <div className="drop-wrapper league-team-wrapper">
                <div className="drop-down">
                  <label>Team</label>
                  <AsyncPaginate
                    key={teamKey}
                    classNamePrefix="cs-new-dropdown"
                    isClearable={true}
                    value={selectedTeams}
                    loadOptions={loadOptionsTeam}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(option) => {
                      setSelectedTeams(option)
                    }}
                    placeholder="Select Team"
                    additional={{
                      page: 1,
                    }}
                    debounceTimeout={1000}
                    styles={customStyles}
                    noOptionsMessage={() => "No Team Found."}
                    className="multivalue-dropdown"
                  // closeMenuOnSelect={false}
                  />
                </div>
              </div>}

              <div className="right">
                {
                  !!showCancelMultiple && <>
                    <button className="btn" onClick={() => {
                      setOpenWarningPopup(true);
                    }}>Cancel Messages</button>
                  </>
                }
              </div>
            </div>
          </div>
          <div className="dataTable">
            <DataTableComponent key="table-admin-users"
              disableRowClicked={true}
              type={'sms-logs'}
              data={userData}
              columns={loadColumns({ columns })}
              onFilterChange={(event) => {
                setFilter((prev) => {
                  if (event.type === 'sort') {
                    return {
                      ...prev,
                      sort_column: event.target.value,
                      direction: event.target.direction,
                    }
                  }
                  return {
                    ...prev,
                    [event.target.name]: Number(event.target.value),
                  }
                })
              }}
              totalPage={totalPage} />
          </div>
        </div>
        <WarningDialogue
          isOpen={openWarningPopup}
          header={'Warning'}
          description={cancelMessagesIds.length > 1 ? 'Are you sure you want to cancel these messages?' : 'Are you sure you want to cancel this message?'}
          action={cancelScheduledMessage}
          onClose={() => setOpenWarningPopup(false)}
        />
      </div>
    </>
  );
}

export default TextLogs;